import React from "react";
import HeroSection from "../components/HeroSection";
import FeaturesBar from "../components/FeaturesBar";
import CategoriesSection from "../components/CategoriesSection";
import FeaturedProducts from "../components/FeaturedProducts";
import CustomizationSection from "../components/CustomizationSection";
import Footer from "../components/Footer";

class SectionBoundary extends React.Component {
  constructor(props) { super(props); this.state = { hasError: false, error: null }; }
  static getDerivedStateFromError(error) { return { hasError: true, error }; }
  componentDidCatch(error, info) { console.error("[Section crash]", this.props.name, error.message); }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{ background: "#fff0f0", border: "2px dashed #c0392b", padding: "20px 24px",
          fontFamily: "Georgia, serif", fontSize: "12px", color: "#c0392b" }}>
          ⚠ "{this.props.name}" error: {this.state.error?.message}
        </div>
      );
    }
    return this.props.children;
  }
}

export default function Home() {
  return (
    <div style={{ overflowX: "hidden" }}>
      <SectionBoundary name="HeroSection">         <HeroSection />          </SectionBoundary>
      <SectionBoundary name="FeaturesBar">         <FeaturesBar />          </SectionBoundary>
      <SectionBoundary name="CategoriesSection">   <CategoriesSection />    </SectionBoundary>
      <SectionBoundary name="FeaturedProducts">    <FeaturedProducts />     </SectionBoundary>
      <SectionBoundary name="CustomizationSection"><CustomizationSection /> </SectionBoundary>
      <SectionBoundary name="Footer">              <Footer />               </SectionBoundary>
    </div>
  );
}